import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: ${props => props.theme.containerWidth};
  margin: 0 auto;
  padding: 16px 20px;

  @media (max-width: ${props => props.theme.breakpoints.md}) {
    padding: 0 24px;
  }
`;
